import { connect } from "react-redux";

import { GetOperatorAwardsAnnotations } from "@app/modules/results/selectors/get-operator-awards-annotations";
import type { ResultsReduxState } from "@app/types/results-redux-types";

import type { ConnectedProps } from "react-redux";

import { QuickFilters as QuickFiltersComponent } from "./quick-filters";

function mapStateToProps(state: ResultsReduxState) {
  const operator_awards_annotations = GetOperatorAwardsAnnotations(state);

  return {
    has_operator_awards: !!operator_awards_annotations.length
  };
}

const connector = connect(mapStateToProps);

export type ConnectorProps = ConnectedProps<typeof connector>;

export const QuickFilters = connector(QuickFiltersComponent);
